module.exports = __webpack_public_path__ + "img/walk.be9c8bbd.svg";